// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Apqb","amount":"Amount_amount__KXbBQ","tip":"Amount_tip__2-w-E","tipHeader":"Amount_tipHeader__3Trxv","tipsWrap":"Amount_tipsWrap__3dxsg"};